<template>
  <div class="aboutUsRoot">
    <div class="abUsPart1">
      <div class="abUsPart1Img"></div>
      <span class="font31">更先进的数据展示与管理⽅案，让世界更美好</span>
      <a href="mailto:hr@spacehorizon.cn" class="addToUs">加入我们</a>
    </div>

    <div class="abUsPart2">
      <span class="font32">我们在做的事前景如何。</span>
      <div class="abUsPart2Sub1Bg">
        <span class="font33">市场⽀持</span>
        <span class="font34"> 越来越多的企业与组织选择在项⽬中应⽤三维地理信息技术。 </span>
      </div>
      <div class="abUsPart2Sub2Bg">
        <span class="font33">市场需求</span>
        <span class="font34">
          三维地理信息系统在项⽬建设中的普遍应⽤，异构⼤数据融合技术在管理中的重要作⽤实景及⼤地建模技术在规划、环保等领域的创新性应⽤，物联⽹集成技术在⼯业物联⽹以及各类项⽬中的⼴泛性应⽤，⼤数据可视化应⽤及业务场景化应⽤的创新，楼宇及园区智能化集成管理应⽤等。
        </span>
      </div>
      <div class="abUsPart2Sub3Bg">
        <span class="font33">公司定位</span>
        <span class="font34">
          时空视界致⼒于为项⽬智慧化、组织管理智能化、⾏业信息化应⽤提供 3D 地理信息系统⼈⼯智能应⽤、时空信息管理⼯具与⼤数据可视化管理平台，改善⽤户体验与提升组织管理效益，致⼒于为各⾏业提供全球领先的数字孪⽣产品和服务。
        </span>
      </div>
    </div>

    <div class="abUsPart3">
      <div class="abUsPart3Left">
        <div class="font35">为什么<br />选择我们。</div>
        <about-us-swiper v-if="reflush" class="usswiper"></about-us-swiper>
      </div>
      <div class="abUsPart3Right"></div>
    </div>

    <!-- <div class="abUsPart4">
      <span class="font36 abUsPart4Title">我们的合作伙伴</span>
      <div class="font37">我们有众多实力强大的合作伙伴</div>
      <div class="partners"></div> -->
      <!-- <span class="font36 abUsPart4Title2">荣誉资质</span>
				<div class="font37">
					公司拥有多项技术专利
				</div>
				<div class="patent1"></div>
				<div class="patent2"></div>
				<div class="patent3"></div> -->
    <!-- </div> -->

    <div class="abUsPart5">
      <div class="abUsPart5Left"></div>
      <div class="font38">联系我们</div>
      <div class="font39 adUsPt5Icon1">中国（福建）自由贸易试验区厦门片区港中路 1728 号103</div>
      <div class="font39 adUsPt5Icon2">林先生</div>
      <div class="font39 adUsPt5Icon3">13600705138</div>
      <div class="font39 adUsPt5Icon4">
        <!-- 0592-5567098
        <div style="width: 10px; display: inline-block"></div> -->
        0592-7701599
      </div>
    </div>
  </div>
</template>

<script>
import AboutUsSwiper from '@/components/AboutUsSwiper.vue'
export default {
  name: 'AboutUs',
  components: {
    AboutUsSwiper,
  },
  data() {
    return {
      reflush: true,
    }
  },
  mounted() {
    var _this = this
    document.title = '时空视界|关于我们'
    window.onresize = function () {
      console.log('尺寸刷新')
      _this.reflush = false
      setTimeout(function () {
        _this.reflush = true
      }, 500)
    }

    if (window.createdCallBack) {
      window.createdCallBack(true)
    }
    if (window.updateNavCallBack) {
      window.updateNavCallBack(3)
    }
  },
}
</script>

<style scoped="scoped">
.abUsPart5Left {
  background-image: url(../../assets/aboutUs/pic_location.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  width: 50%;
  height: 100%;
  float: left;
}
.adUsPt5Icon1 {
  background-image: url(../../assets/aboutUs/icon_location.png);
  background-repeat: no-repeat;
  background-size: 17px 24px;
  padding-left: 33px;
}
.adUsPt5Icon2 {
  background-image: url(../../assets/aboutUs/icon_person.png);
  background-repeat: no-repeat;
  background-size: 17px 24px;
  padding-left: 33px;
}
.adUsPt5Icon3 {
  background-image: url(../../assets/aboutUs/icon_phone.png);
  background-repeat: no-repeat;
  background-size: 17px 24px;
  padding-left: 33px;
}
.adUsPt5Icon4 {
  background-image: url(../../assets/aboutUs/icon_Telephone.png);
  background-repeat: no-repeat;
  background-size: 17px 24px;
  padding-left: 33px;
}
.font39 {
  font-size: 24px;
  /* font-family: SourceHanSansK-Normal; */
  color: #e9e9e9;
  line-height: 24px;
  text-align: left;
  margin-left: 1021px;
  margin-bottom: 36px;
}
.font38 {
  margin-bottom: 75px;
  font-size: 60px;
  /* font-family: SourceHanSansK-Normal; */
  font-weight: bold;
  color: #e9e9e9;
  line-height: 70px;
  letter-spacing: 2px;
  text-align: left;
  margin-left: 1021px;
  padding-top: 120px;
  width: 435px;
  height: 208px;
  background-image: url(../../assets/aboutUs/contact%20us.png);
  background-repeat: no-repeat;
  background-position: 0px 210px;
  background-size: 80%;
}
.abUsPart5 {
  height: 800px;
  background-color: #1d1d20;
}
.patent1 {
  width: 371px;
  height: 505px;
  display: inline-block;
  /* background-color: #1D1D20; */
  background-image: url(../../assets/aboutUs/图片1.png);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}
.patent2 {
  width: 499px;
  height: 680px;
  display: inline-block;
  /* background-color: #1D1D20; */
  background-image: url(../../assets/aboutUs/图片1.png);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  margin-left: 45px;
  margin-right: 45px;
  margin-top: 80px;
}
.patent3 {
  width: 371px;
  height: 505px;
  display: inline-block;
  /* background-color: #1D1D20; */
  background-image: url(../../assets/aboutUs/图片1.png);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}
.abUsPart4Title2 {
  margin-top: 149px;
}
.partners {
  width: 100%;
  height: 309px;
  background-image: url(../../assets/aboutUs/logo_parter.png);
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin-top: 100px;
}
.font37 {
  font-size: 30px;
  /* font-family: SourceHanSansK-Normal; */
  font-weight: 400;
  color: #666666;
  line-height: 45px;
  letter-spacing: 1px;
}
.abUsPart4Title {
  padding-top: 140px;
  /* font-family: SourceHanSansKBold-Bold !important; */
  font-weight: bold;
}
.font36 {
  font-size: 60px;
  /* font-family: SourceHanSansK-Normal; */
  font-weight: bold;
  color: #000000;
  line-height: 90px;
  letter-spacing: 2px;
  display: block;
  text-align: center;
}
.abUsPart4 {
  height: 763px;
}
.font35 {
  position: absolute;
  font-size: 60px;
  /* font-family: SourceHanSansKBold-Bold; */
  font-weight: bold;
  color: #e9e9e9;
  line-height: 70px;
  letter-spacing: 2px;
  margin-left: 260px;
  padding-top: 120px;
  text-align: left;
}
.usswiper {
  margin-top: 410px;
  float: left;
  width: 100%;
}
.abUsPart3Right {
  width: 50%;
  display: inline-block;
  height: 800px;
  background-image: url(../../assets/aboutUs/pic_team_companypage.jpg);
  background-repeat: no-repeat;
  background-size: cover;
}

.abUsPart3Left {
  width: 50%;
  display: inline-block;
  height: 800px;
  background-color: #1d1d20;
  float: left;
}
.abUsPart3 {
  height: 800px;
}
.font34 {
  font-size: 24px;
  /* font-family: SourceHanSansK-Regular; */
  color: #e9e9e9;
  line-height: 36px;
  letter-spacing: 1px;
  position: absolute;
  margin-top: 156px;
  display: block;
  width: 375px;
}
.font33 {
  font-size: 36px;
  /* font-family: SourceHanSansK-Medium; */
  font-weight: 500;
  color: #e9e9e9;
  line-height: 54px;
  float: left;
  margin-top: 88px;
}
.abUsPart2Sub1Bg {
  background-image: url(../../assets/aboutUs/icon_zc.png);
  background-size: 60px 60px;
  background-repeat: no-repeat;
  width: 19.53%;
  height: 500px;
  margin-top: 236px;
  display: inline-block;
  text-align: left;
}
.abUsPart2Sub2Bg {
  background-image: url(../../assets/aboutUs/icon_sc.png);
  background-size: 60px 60px;
  background-repeat: no-repeat;
  width: 19.53%;
  height: 500px;
  margin-top: 236px;
  margin-left: 134px;
  display: inline-block;
  text-align: left;
}
.abUsPart2Sub3Bg {
  background-image: url(../../assets/aboutUs/icon_dw.png);
  background-size: 60px 60px;
  background-repeat: no-repeat;
  width: 19.53%;
  height: 500px;
  margin-top: 236px;
  margin-left: 134px;
  display: inline-block;
  text-align: left;
}
.font32 {
  font-size: 60px;
  /* font-family: SourceHanSansKBold-Bold; */
  font-weight: bold;
  color: #e9e9e9;
  line-height: 70px;
  display: block;
  width: 420px;
  height: 140px;
  margin-left: 13.54%;
  padding-top: 128px;
  text-align: left;
}
.abUsPart2 {
  height: 1044px;
  background-image: url(../../assets/aboutUs/bg_qianjing.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}
.addToUs {
  display: block;
  width: 160px;
  height: 50px;
  background: linear-gradient(180deg, #00b7fb 0%, #0080f6 100%);
  border-radius: 25px;
  font-size: 24px;
  /* font-family: SourceHanSansK-Normal; */
  font-weight: bold;
  color: #ffffff;
  line-height: 50px;
  margin: 0 auto;
  top: 180px;
  position: relative;
  text-decoration: none;
}
.font31 {
  font-size: 44px;
  /* font-family: SourceHanSansK-Normal; */
  font-weight: 400;
  color: #e9e9e9;
  line-height: 32px;
  width: 100%;
  padding-top: 284px;
  display: block;
}
.abUsPart1Img {
  background-image: url(../../assets/aboutUs/SPACE-TIME%20HORIZON.png);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  height: 80px;
  width: 100%;
  margin-top: 145px;
  float: left;
}
.abUsPart1 {
  height: 700px;
  background-image: url(../../assets/aboutUs/pic_head_about.jpg);
  background-size: cover;
  background-color: #1d1d20;
  background-repeat: no-repeat;
  background-position: center;
}
.aboutUsRoot {
  text-align: center;
  width: 1920ox;
}
</style>
